module.exports = __webpack_public_path__ + "static/media/Calibre-SemiboldItalic.6473be72.woff";